import React from "react"

const Card = (props) => {
  return (
    <>
      <div className='box btn_shadow d_flex'>
        <img src={props.image} alt='Skill Icon' className="skillsIcon" />
        <h2>{props.title}</h2>
        <a href='/'>
          <i className='fas fa-arrow-right'></i>
        </a>
      </div>
    </>
  )
}

export default Card
